import { useEffect, useState } from "react";
import React from "react";
import "./Navigation.css"

var currentPage;
const buttons = {
    art:{ text: `A r t`, link: `#/art` },
    break1:{ text:`/` },
    projects:{ text: `W o r k`, link: `#/work` },
    break2:{ text:`/` },
    about:{ text: `A b o u t`, link: `#/about` }
}

// On page load; Add the "nav-active" css class to nav button whose page is currently loaded.
window.addEventListener('load', function(){
    let mobileCurrent = this.document.getElementById("currentTab");
    const navButtons = this.document.getElementsByClassName("nav-button");

    Array.prototype.forEach.call(navButtons, function(element){
        // yucky full nested if statements :p
        if (element.href.includes(window.location.hash)){
            element.classList.add("nav-active");
           
            // Really check if mobileCurrent is not null. Needed to prevent desktop view errors.
            if (typeof mobileCurrent !== 'undefined' && mobileCurrent !== null){ 
                mobileCurrent.innerHTML = element.innerHTML;
            }
        }
    });
});

// On page state change: Remove "nav-active" from all nav buttons whose page currently is not loaded.
window.addEventListener('popstate', function (event){
    const navButtons = this.document.getElementsByClassName("nav-button");
    Array.prototype.forEach.call(navButtons, function(element) {!element.href.includes(window.location.hash) && element.classList.remove("nav-active");})
});

function Navigation({onTabClicked}){
    const isMobile = window.innerWidth <= 768;
    return( isMobile ? <MobileNavBar onTabClicked={onTabClicked}/> : <DesktopNavBar onTabClicked={onTabClicked}/> );
}

// Desktop Nav Components
function DesktopNavBar({onTabClicked}){
    return(
        <div name="navigation" className="row text-center desktop-navbar TopSeperator">
            <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                {Object.keys(buttons).map((key) => <DesktopNavButton key={key} button={buttons[key]}  callable={onTabClicked}/> )}
            <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
        </div>
    );
}
function DesktopNavButton({button, callable}){
    function onClickHandler(e){
        e.target.classList.add("nav-active");
        callable(button.link);
    }
    return(
        <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 navbar-button">
            {button.text === "/" ? button.text : <a className="nav-button" href={button.link} onClick={onClickHandler}>{button.text}</a>}
        </div>
    );
}

// Mobile Nav Components
function MobileNavBar({onTabClicked}){
    const [toggleDropDown, setDropDownState] = useState(false);
    function onDropDownClicked(){
        setDropDownState((toggleDropDown) => !toggleDropDown);
    }
    return(
        <div className="text-center TopSeperator mobile-navbar">
            <div className="row mobile-current">
                <a id="currentTab" className="nav-active" onClick={onDropDownClicked}>{currentPage}</a>
                <a onClick={onDropDownClicked} className="icon"><i className="fa fa-bars"></i></a>
            </div>

            <div name="dropdown" className="row" style={{display : toggleDropDown ? "block" : "none"}}>
                {Object.keys(buttons).map((key) => <MobileNavButton key={key} button={buttons[key]} callable={onTabClicked} clicked={onDropDownClicked}/>)}
            </div>
        </div>
    );
}

function MobileNavButton({button, callable, clicked}){
    function onClickHandler(e){
        e.target.classList.add("nav-active");
        currentPage = button.text;
        callable(button.link);
        clicked()
    }
    return(
        <div className="row navbar-button">
            {"link" in button ? <a className="nav-button" href={button.link} onClick={onClickHandler}>{button.text}</a> : <hr/>}
        </div>
    );
}

export default Navigation